// extracted by mini-css-extract-plugin
export default {"wrapper":"style--wrapper--2bdb98"};